import React from "react";
import { Box, Typography } from "@mui/material";
import { getSeoColor, getSeoLabel } from "../../utils/seo/calculateSeoScore";

/**
 * SeoScorePanel Component
 * Displays the large circular/dial view of the 0-100 SEO score.
 */
const SeoScorePanel = ({ score }) => {
  const color = getSeoColor(score);
  const label = getSeoLabel(score);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 4,
        px: 2,
        mb: 3,
        borderRadius: "16px",
        background: `linear-gradient(135deg, ${color}15 0%, #FFFFFF 100%)`,
        border: `1px solid ${color}30`,
      }}
    >
      <Typography
        variant="overline"
        sx={{
          color: "#64748B",
          fontWeight: 700,
          letterSpacing: "1px",
          mb: 1,
        }}
      >
        Overall SEO Score
      </Typography>

      <Box
        sx={{
          width: 120,
          height: 120,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: `6px solid ${color}`,
          backgroundColor: "#FFFFFF",
          boxShadow: `0 8px 16px ${color}20`,
          mb: 2,
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            color: "#1E293B",
            fontFamily: "Kamerik",
          }}
        >
          {score}
        </Typography>
      </Box>

      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          color: color,
        }}
      >
        {label}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: "#64748B",
          textAlign: "center",
          mt: 1,
          maxWidth: "80%",
        }}
      >
        Aim for a score above 70 for optimal search engine ranking.
      </Typography>
    </Box>
  );
};

export default SeoScorePanel;
